import { logger } from "./logger";

export function filterAirbnbResults(
  results,
  { airbnbType, minReviewCount, minReviewScore, advancedFilters }
) {
  if (!Array.isArray(results)) {
    logger.warn("filterAirbnbResults expected an array but got:", results);
    return [];
  }
  return results.filter((result) => {
    const type = result.type?.toLowerCase() || "";

    const matchesType =
      airbnbType === "both" ||
      (airbnbType === "entire_home" &&
        !type.includes("private") &&
        (type.includes("entire") ||
          type.includes("apartment") ||
          type.includes("house") ||
          type.includes("home"))) ||
      (airbnbType === "private_room" &&
        type.includes("private") &&
        type.includes("room"));

    const meetsReviewCount = result.reviewsCount >= minReviewCount;
    const meetsReviewScore = result.rating >= minReviewScore;

    const matchesAmenities = Object.entries(advancedFilters)
      .filter(([key, value]) => key.startsWith("amenity_") && value)
      .every(([key]) => {
        const id = Number(key.replace("amenity_", ""));
        return result.amenityIds?.includes(id);
      });

    const matchesSuperhost =
      !advancedFilters.superhostOnly || result.isSuperhost === true;

    const matchesCancelPolicy =
      !advancedFilters.cancelPolicies ||
      advancedFilters.cancelPolicies.length === 0 ||
      advancedFilters.cancelPolicies.some((selectedPolicy) => {
        if (!result.cancelPolicy) return false;

        if (selectedPolicy === "Strict") {
          return result.cancelPolicy.toUpperCase().includes("STRICT");
        }

        return (
          result.cancelPolicy.toUpperCase() ===
          `CANCEL_${selectedPolicy.toUpperCase()}`
        );
      });

    const totalPrice = result.price?.total;

    const nightsInfo = result.price?.priceItems?.find((item) =>
      item.title.toLowerCase().includes("night")
    );
    const numberOfNights = parseInt(
      nightsInfo?.title?.match(/x\s*(\d+)\s*nights?/i)?.[1] || "1",
      10
    );
    const nightlyPrice =
      totalPrice && numberOfNights > 0
        ? totalPrice / numberOfNights
        : totalPrice;

    const matchesMinPrice =
      advancedFilters.minPrice == null ||
      nightlyPrice == null ||
      nightlyPrice >= advancedFilters.minPrice;

    const matchesMaxPrice =
      advancedFilters.maxPrice == null ||
      nightlyPrice == null ||
      nightlyPrice <= advancedFilters.maxPrice;

    return (
      matchesType &&
      meetsReviewCount &&
      meetsReviewScore &&
      matchesSuperhost &&
      matchesCancelPolicy &&
      matchesAmenities &&
      matchesMinPrice &&
      matchesMaxPrice
    );
  });
}
